import { useCallback } from "react";

const STICKY_HEADER_SELECTOR = "header.sticky";
const DEFAULT_GAP_PX = 12;

export function useScrollTo(id: string, gap = DEFAULT_GAP_PX): () => void {
    return useCallback(() => {
        const target = document.getElementById(id);
        if (!target) return;

        const header = document.querySelector(STICKY_HEADER_SELECTOR);
        const headerHeight = header?.getBoundingClientRect().height ?? 64;
        const top = target.getBoundingClientRect().top + window.scrollY - headerHeight - gap;

        window.scrollTo({ top: Math.max(0, top), behavior: "smooth" });
    }, [id, gap]);
}
